































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ViewAllUsersModal from './ViewAllUsers.modal.vue'

@Component({
  components: {
    ViewAllUsersModal
  }
})
export default class OverviewUsers extends Vue {
  @Prop() dateTo?: Date;
  @Prop() dateFrom?: Date;
  @Prop() marketKey?: string;
  @Prop() markets?: any;
  logins: any = []
  totalCount: number = 0
  fields: any[] = [{ key: 'users_firstName', label: 'Name' }, { key: 'users_secondName', label: 'Surname' }, { key: 'users_email', label: 'Email' }, { key: 'max', label: 'Last login', formatter: this.formatDate }, { key: 'count', label: 'Login count' }]

  @Watch('markets')
  @Watch('dateTo')
  @Watch('dateFrom')
  @Watch('marketKey')
  async getUserLogins () {
    await this.$store.dispatch('getUserLogins', { dateTo: this.dateTo, dateFrom: this.dateFrom, marketKey: this.marketKey }).then((res: any) => {
      this.logins = res.users
      this.totalCount = res.totalCount
      this.$emit('increment')
    })
  }

  formatDate (date: string) {
    // format date with time
    return new Date(date).toLocaleString()
  }

  get currentMarket () {
    const market = this.markets.find((market: any) => market.value === this.marketKey)
    return market.text
  }

  get topLogins () {
    return this.logins.length ? this.logins.filter((x: { count: number; }) => x.count > 0).slice(0, 5) : []
  }
}
